'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PSFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-utgjlbalb", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-utgjlbalb)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 0h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 16h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 2l16 10L0 22z" })))
  );
}

export { PSFlag };
//# sourceMappingURL=PS.mjs.map
